const $ = require('jquery');
import _ from "underscore";
import { setElementsFromScope, setOptionsForSelect } from "../../utilities/selectorHelpers";
import timePicker from "../../components/timePicker/timePicker";
require("./standardPlatformFacilitySetupWizard.less");
// Additional Imports...

const elementsMap = {
  dayShift: ".day-shift",
  dayShiftCheckbox: ".day-shift-checkbox"
}
let els = {};

export default function CalendarTab(wizard) {
  const self = this;
  const wizardEl = wizard.getWizardElement();
  const facData = wizardEl.data("load-edit-facility"); //get the facility data from DB to load edit form
  let calendarTimes = [];
  if(!_(facData).isEmpty()) {
    calendarTimes = facData.facilitiesCalendarSet;
  }

  let shiftTimes = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: []
  }
  let selectedShiftTimes = {};
  let selectedDays = {};
  // Enable it when we have the Edit flow 
  let savedShiftTimes = {};

  (calendarTimes).map((day)=>{
    savedShiftTimes[`${day.facCalendarDay.toLowerCase()}`] = [
      {
        from: `${day.facCalendarStartTime}`,
        to: `${day.facCalendarEndTime}`
      }      
    ]
  });

  self.init = function () {
    setElements();
    bindElements();
    instantiateCalendarArea();

  }

  function instantiateCalendarArea() {
    els.dayShift.each((index, el) => {
      const $el = $(el);
      const checkBox = $el.find('.day-shift-checkbox');
      const dayOfWeek = $el.data('day-of-week');
      const timePickerArea = $el.find('.time-picker-area');
      const timeFrom = timePicker(timePickerArea.find('.time-picker-from'));
      const timeTo = timePicker(timePickerArea.find('.time-picker-to'));
      shiftTimes[dayOfWeek].push({ timeFrom, timeTo });
      if(!savedShiftTimes.hasOwnProperty(dayOfWeek)){
        timeFrom.disableTimePicker();
        timeTo.disableTimePicker();
      }

      if(savedShiftTimes[dayOfWeek] && savedShiftTimes[dayOfWeek].length > 0) {
        shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
        timeFrom.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].from);
        timeTo.setTimeFromMilitary(savedShiftTimes[dayOfWeek][0].to);
        checkBox.trigger('click');
      }
    });
  }

  self.getCalendarShiftTimes = function () {
    Object.keys(shiftTimes).forEach((key) => {
      if (selectedDays[key]) {
        selectedShiftTimes[key] = shiftTimes[key].map((el) => {
          return {
            from: el.timeFrom.getMilitaryTime(),
            to: el.timeTo.getMilitaryTime()
          }
        });
      } else {
        delete selectedShiftTimes[key];
      }
    });
    return selectedShiftTimes;
  }

  self.showInvalidShiftError = function (dayArr) {
    els.dayShift.each((index, el) => {
      const $el = $(el);
      const dayOfWeek = $el.data('day-of-week');
      const error = $el.find('.time-picker-error');
      if (_(dayArr).contains(dayOfWeek)) {
        error.css('display', 'block');
      } else {
        error.css('display', 'none');
      }
    });
  }

  function setElements() {
    // set Elements for time picker objects
    setElementsFromScope(els, elementsMap, wizardEl);
  }

  function bindElements() {
    els.dayShiftCheckbox.on("click", handleDayShiftCheckboxChange);
  }

  function handleDayShiftCheckboxChange() {
    let isChecked = $(this).is(':checked');
    let dayOfWeek = $(this).closest('.day-shift').data('day-of-week');
    if (isChecked) {
      shiftTimes[dayOfWeek][0].timeFrom.enableTimePicker();
      shiftTimes[dayOfWeek][0].timeTo.enableTimePicker();
      selectedDays[dayOfWeek] = isChecked;
    } else {
      shiftTimes[dayOfWeek][0].timeFrom.resetTime();
      shiftTimes[dayOfWeek][0].timeTo.resetTime();
      shiftTimes[dayOfWeek][0].timeFrom.disableTimePicker();
      shiftTimes[dayOfWeek][0].timeTo.disableTimePicker();
      $(this).closest('.day-shift').find('.time-picker-error').css('display', 'none');
      delete selectedDays[dayOfWeek];
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/standardPlatformFacilitySetupWizard/calendarTab.js